<template>
    <div class="teaching_data">
        <div class="data_nav">
            <button
                v-for="(item, index) in menu"
                :key="item.name"
                type="button"
                class="tab_item"
                :class="{ active: currentIndex === index }"
                @click="changeMenu(index)"
            >
                {{ item.name }}
            </button>
        </div>
        <div class="view_context">
            <span>当前视图</span>
            <strong>{{ menu[currentIndex].name }}</strong>
        </div>

        <div v-if="currentIndex == 0" class="chart_list">
            <section class="chart_card"><div id="zpsj" class="chart_canvas"></div></section>
            <section class="chart_card"><div id="yhsj" class="chart_canvas"></div></section>
            <section class="chart_card"><div id="bssj" class="chart_canvas"></div></section>
            <section class="chart_card"><div id="kjsj" class="chart_canvas"></div></section>
        </div>
        <tab-1 v-else-if="currentIndex == 1" />
        <tab-2 v-else-if="currentIndex == 2" />
        <tab-3 v-else-if="currentIndex == 3" />
        <tab-4 v-else-if="currentIndex == 4" />
    </div>
</template>

<script>

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LegendComponent
} from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import tab1 from './components/tab1.vue';
import tab2 from './components/tab2.vue';
import tab3 from './components/tab3.vue';
import tab4 from './components/tab4.vue';

// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LegendComponent,
    BarChart,
    LineChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer
]);
export default {
    components: { tab1, tab2, tab3, tab4 },
    data () {
        return {
            menu: [
                { name: "数据大屏" },
                { name: "作品创作统计" },
                { name: "比赛统计" },
                { name: "课件统计" },
                { name: "参与人数统计" },
            ],
            currentIndex: 0
        };
    },
    mounted () {
        this["init" + this.currentIndex]();
        window.addEventListener('resize', this.resizeCharts);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.resizeCharts);
        this.disposeCharts();
    },
    methods: {
        changeMenu (index) {
            if (this.currentIndex === index) return;
            this.disposeCharts();
            this.currentIndex = index;
            this.$nextTick(() => this['init' + index]());
        },

        // 数据大屏
        init0 () {
            const getChart = (url, id, title, type = "bar") => {
                this.$ajax.post(url, {}).then(res => {
                    const chartElement = document.getElementById(id);
                    if (!chartElement) return;
                    const domChart = echarts.getInstanceByDom(chartElement) || echarts.init(chartElement);
                    const dataset = res.data && res.data.dataset ? res.data.dataset : [];
                    const source = dataset[0]
                        ? dataset[0].source || []
                        : [];
                    let series = [];
                    for (let i = 0; i < Math.max(source.length - 1, 0); i++) {
                        series.push({
                            type,
                            seriesLayoutBy: 'row',
                            barMaxWidth: 26,
                            smooth: type === 'line',
                            symbolSize: type === 'line' ? 7 : undefined,
                            lineStyle: type === 'line' ? { width: 3 } : undefined,
                        });
                    }

                    let option = {
                        color: ['#21965b', '#8ccf9f', '#5577c9', '#d8a344'],
                        title: {
                            text: title,
                            left: 4,
                            top: 2,
                            textStyle: {
                                color: '#1d2922',
                                fontSize: 18,
                                fontWeight: 600,
                            },
                        },
                        legend: {
                            top: 5,
                            right: 8,
                            itemWidth: 16,
                            itemHeight: 9,
                            textStyle: { color: '#657269', fontSize: 12 },
                        },
                        grid: { left: 12, right: 12, top: 66, bottom: 8, containLabel: true },
                        tooltip: {
                            trigger: 'axis',
                            backgroundColor: 'rgba(24, 32, 28, .92)',
                            borderWidth: 0,
                            textStyle: { color: '#fff' },
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: { lineStyle: { color: '#dfe7e1' } },
                            axisTick: { show: false },
                            axisLabel: { color: '#758078', fontSize: 12 },
                        },
                        yAxis: {
                            splitLine: { lineStyle: { color: '#edf2ee' } },
                            axisLabel: { color: '#758078', fontSize: 12 },
                        },
                        dataset,
                        series: series,
                    };
                    domChart.setOption(option, true);
                    this._charts = this._charts || [];
                    if (this._charts.indexOf(domChart) === -1) this._charts.push(domChart);
                })
            }

            getChart("/report/product", "zpsj", "作品数据", "bar")
            getChart("/report/user", "yhsj", "用户数据", "line")
            getChart("/report/competition", "bssj", "比赛数据", "bar")
            getChart("/report/courseware", "kjsj", "课件数据", "bar")
        },
        // 作品创作统计
        init1 () { },
        // 比赛统计
        init2 () { },
        // 课件统计
        init3 () { },
        // 参与人数统计
        init4 () { },
        resizeCharts () {
            (this._charts || []).forEach(chart => chart.resize());
        },
        disposeCharts () {
            (this._charts || []).forEach(chart => chart.dispose());
            this._charts = [];
        },
    },
};
</script>

<style lang="scss" scoped>
.teaching_data {
    padding: 0;

    .data_nav {
        display: grid;
        grid-template-columns: repeat(5, minmax(120px, 1fr));
        gap: 8px;
        padding: 8px;
        border: 1px solid #e5ece7;
        border-radius: 18px;
        background: #fff;
        box-shadow: 0 10px 28px rgba(41, 76, 56, .05);
    }

    .tab_item {
        min-height: 48px;
        padding: 0 14px;
        border: 0;
        border-radius: 12px;
        text-align: center;
        color: #66736b;
        background: transparent;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all .2s ease;

        &:hover {
            color: #21965b;
            background: #f1faf5;
        }

        &.active {
            color: #fff !important;
            background: #21965b;
            box-shadow: 0 8px 18px rgba(33, 150, 91, .2);

            &:hover {
                color: #fff !important;
            }
        }
    }

    .view_context {
        display: flex;
        align-items: center;
        gap: 9px;
        margin: 18px 2px 14px;
        color: #89948d;
        font-size: 13px;

        strong {
            color: #21965b;
            font-weight: 650;
        }
    }

    .chart_list {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 18px;
        width: 100%;
        margin: 0;

        .chart_card {
            min-width: 0;
            padding: 20px;
            border: 1px solid #e5ece7;
            border-radius: 20px;
            background: #fff;
            box-shadow: 0 12px 30px rgba(41, 76, 56, .06);
        }

        .chart_canvas {
            width: 100%;
            height: 310px;
        }
    }
}

@media (max-width: 1100px) {
    .teaching_data {
        .data_nav {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        .chart_list {
            grid-template-columns: 1fr;
        }
    }
}

@media (max-width: 720px) {
    .teaching_data {
        .data_nav {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        .chart_list .chart_card {
            padding: 14px;
        }
    }
}
</style>
